import { Component, OnChanges, inject, ChangeDetectionStrategy, input, output } from '@angular/core';
import { EntityLine } from '../../../entity/entity-line';
import { TagInformation } from '../../../model/tag-information';
import { GuruEntity } from '../../../model/guru-entity';
import { ModelService } from '../../../services/model-service';
import { SelectionUtils } from '../../selection-utils';
import { ConfigurationSection, UserStateService } from '../../../services/user-state.service';
import { DialogService } from '../../../services/dialog.service';
import { FormsModule } from '@angular/forms';
import { MatButton } from '@angular/material/button';

import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'app-unit-information',
  templateUrl: './unit-information.component.html',
  styleUrls: ['./unit-information.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatIcon, MatButton, FormsModule],
})
export class UnitInformationComponent implements OnChanges {
  private modelService = inject(ModelService);
  private userStateService = inject(UserStateService);
  private dialogService = inject(DialogService);
  readonly lineInput = input.required<EntityLine>({ alias: 'line' });
  readonly isOem = input.required<boolean>();
  readonly tags = input.required<TagInformation[]>();
  readonly invalidEntities = input.required<string[]>();
  readonly engineKey = input.required<string>();
  readonly selectionEntities = input.required<GuruEntity[]>();
  readonly tagInformationUpdated = output<TagInformation[]>();
  readonly valueChanged = output<void>();
  readonly quantityChanged = output<void>();
  packagingSelection!: GuruEntity;
  shippingSelection!: GuruEntity;
  isExpanded = true;
  private sectionKey = ConfigurationSection.UNIT_INFORMATION;

  constructor() {
    this.isExpanded = !this.userStateService.isConfigurationSectionCollapsed(this.sectionKey);
  }

  ngOnChanges(): void {
    this.packagingSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USPackaging');
    this.shippingSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USShipping');
  }

  invalidTags(): boolean {
    return this.lineInput() && this.tags() && this.lineInput().quantityExtended !== this.tags().length;
  }

  showTagsDialog(): void {
    this.dialogService.showTagManagementDialog(this.tags() || [], 640, this.lineInput().quantityExtended, false).subscribe({
      next: (result: TagInformation[]) => {
        if (result && result.length > 0) {
          this.tagInformationUpdated.emit(result);
        }
      },
    });
  }

  updateQuantity(): void {
    this.quantityChanged.emit();
  }

  selectionChanged(entity: GuruEntity, newValue: string): void {
    entity.Value = newValue;
    this.modelService.setValue(entity.Name, this.engineKey(), newValue).subscribe(() => this.valueChanged.emit());
  }

  toggleExpansion(): void {
    this.isExpanded = !this.isExpanded;
    this.userStateService.setCollapsedValue(this.sectionKey, this.isExpanded);
  }

  getExpansionIcon(): string {
    return this.isExpanded ? 'arrow_drop_up' : 'arrow_drop_down';
  }

  isInvalidSelection(entityName: string) {
    return this.invalidEntities() && this.invalidEntities().indexOf(entityName) >= 0;
  }
}
